// Author lgq
// Date 2022-02-23 13:53:31

class EmSicBackgroundImageSbi {
constructor({
        id = null,
        sbiName = '',
        sbiAttachment = '',
        remark = '',
        sbiAttachmentList = ''}
= {}) {
    this.id = id;
    this.sbiName = sbiName;
    this.sbiAttachment = sbiAttachment;
    this.remark = remark;
    this.sbiAttachmentList = sbiAttachmentList;
}
}

function newEntity() {
return new EmSicBackgroundImageSbi();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.statusCollection.emSicBackgroundImageSbi.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'sbiName',
        label: 'label.em.statusCollection.emSicBackgroundImageSbi.grid.sbiName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'sbiAttachmentList',
        label: 'label.em.statusCollection.emSicBackgroundImageSbi.grid.sbiAttachmentList',
        sortable: true,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.em.statusCollection.emSicBackgroundImageSbi.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    sbiNameFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'sbiNameFilter',
        label: 'label.em.statusCollection.emSicBackgroundImageSbi.filter.sbiName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'sbiName',
        label: 'label.em.statusCollection.emSicBackgroundImageSbi.entity.sbiName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.em.statusCollection.emSicBackgroundImageSbi.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'sbiAttachmentList',
        label: 'label.em.statusCollection.emSicBackgroundImageSbi.entity.sbiAttachment',
        sortable: false,
        disabled: false,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
            ,correspondingField: 'sbiAttachment'
                }
        }
]

export {EmSicBackgroundImageSbi, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
